<ig-row>
    <ig-col [xs]="6" class="full-height">
        <div class="flex items-center justify-start gap-2">
            <h3>Accounts</h3><span>(all: {{liveCount + deadCount}}, live: {{liveCount}}, disabled: {{deadCount}})</span>
        </div>
        <ig-list>
            <div header>
                <ig-list-column-header>
                    Account name
                </ig-list-column-header>
            </div>
            <div body class="account-list overflow-auto">
                <ig-list-item *ngFor="let account of accounts"
                    matTooltip="{{account.status==='dead'?'Account disabled':''}}">
                    <div [ngStyle]="{'text-decoration':account.status==='dead'?'line-through':'none'}">
                        {{account.userName}}
                    </div>
                    <ig-row-action-buttons *ngIf="!account.isAdministrator">
                        <mat-icon matTooltip="Open client dashboard" (click)="openClientDashboard(account)">
                            open_in_new
                        </mat-icon>
                        <mat-icon (click)="changeIgVersion(account)">
                            <img src="https://iti-images.s3.amazonaws.com/imgs/iti-s.png" alt="new version" width="22px"
                                height="22px" matTooltip="Change ImGoing version!">
                        </mat-icon>
                        <mat-icon (click)="travelBuddySettings(account)">
                            <img src="https://iti-images.s3.amazonaws.com/imgs/ai-star.gif" alt="travel buddy"
                                width="22px" height="22px" matTooltip="Travel Buddy Settings!">
                        </mat-icon>
                        <mat-icon matTooltip="Get JSON feed API key for this account" (click)="getAPIKey(account)">
                            attach_money
                        </mat-icon>
                        <mat-icon matTooltip="view users of this account" (click)="showUsers(account)">
                            person
                        </mat-icon>
                        <mat-icon matTooltip="view place count for this account" (click)="getPlaceCount(account)">
                            functions
                        </mat-icon>
                        <mat-icon matTooltip="set place source" (click)="setPlaceSource(account)">
                            call_split
                        </mat-icon>
                        <mat-icon
                            matTooltip="is this a real client account (this will lead to the different update frequency of the FB images)?"
                            (click)="toggleClientAccount(account)">
                            grade
                        </mat-icon>
                        <mat-icon matTooltip="Manage Event Pages" (click)="eventSpider(account)">
                            bug_report
                        </mat-icon>
                        <mat-icon matTooltip="Show Event Count" (click)="showEventCount(account)">
                            zoom_in
                        </mat-icon>
                        <mat-icon matTooltip="Turn On/Off Features" (click)="toggleFeatures(account)">
                            check_box
                        </mat-icon>
                        <mat-icon matTooltip="Set client contacts" (click)="SetClientContacts(account)">
                            person
                        </mat-icon>
                        <mat-icon matTooltip="Set events and place for default approved or unnaproved"
                            (click)="SetDefaultApproved(account)">
                            settings
                        </mat-icon>
                        <!--<mat-icon matTooltip="Set to simple menu bar"-->
                        <!--*ngIf="!account.customSettings||!account.customSettings.menuStyle||!account.customSettings.menuStyle.menuBar||account.customSettings?.menuStyle?.menuBar==='normal'"-->
                        <!--(click)="menuBar(account, false)">-->
                        <!--drag_handle-->
                        <!--</mat-icon>-->
                        <!--<mat-icon matTooltip="Set to normal menu bar"-->
                        <!--*ngIf="account.customSettings?.menuStyle?.menuBar==='simple'"-->
                        <!--(click)="menuBar(account, true)">-->
                        <!--reorder-->
                        <!--</mat-icon>-->
                        <mat-icon matTooltip="Disable" *ngIf="account.status==='live'"
                            (click)="disableAccount(account)">
                            block
                        </mat-icon>
                        <mat-icon matTooltip="Enable" *ngIf="account.status==='dead'" (click)="enableAccount(account)">
                            reply
                        </mat-icon>
                        <mat-icon matTooltip="Delete" (click)="deleteAccount(account)">
                            clear
                        </mat-icon>
                    </ig-row-action-buttons>
                </ig-list-item>
            </div>
        </ig-list>
    </ig-col>
    <ig-col [xs]="6">
        <h3>Create new account</h3>
        <form class="create-account-form" ngForm="createAccountFormGroup" autocomplete="off">
            <ig-mat-field label="User name" [(ngModel)]="createAccountCommand.userName"
                [formControl]="createAccountFormGroup.get('userName')">
            </ig-mat-field>

            <ig-mat-field label="Password" type="password" [(ngModel)]="createAccountCommand.password"
                [formControl]="createAccountFormGroup.get('password')">
            </ig-mat-field>

            <ig-button [isAsync]="true" [disabled]="createAccountFormGroup.invalid" (trigger)="createAccount($event)">
                Create
            </ig-button>
        </form>
    </ig-col>
</ig-row>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/admin/accounts/accounts.component.html